import { cn } from "@/shared/utils/cn";
import { useTranslation } from "react-i18next";

interface AiImageBadgeProps {
  /** Positions the badge, the parent needs to be relative. */
  className?: string;
}

/** Small black "AI" tag on top of an AI generated image. */
const AiImageBadge = ({ className }: AiImageBadgeProps) => {
  const { t } = useTranslation();
  return (
    <span
      title={t("imageLibrary.source.ai")}
      className={cn(
        "pointer-events-none absolute bottom-1 left-1 z-1 rounded-[0.4rem] bg-[#000] px-2 py-[0.1rem] text-[1rem] font-bold leading-[1.4rem] tracking-wide text-[#fff]",
        className
      )}
    >
      AI
    </span>
  );
};

export default AiImageBadge;
